import { render, staticRenderFns } from "./AdminInactive2026List.vue?vue&type=template&id=0be7bdf7&scoped=true"
import script from "./AdminInactive2026List.vue?vue&type=script&lang=js"
export * from "./AdminInactive2026List.vue?vue&type=script&lang=js"
import style0 from "./AdminInactive2026List.vue?vue&type=style&index=0&id=0be7bdf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be7bdf7",
  null
  
)

export default component.exports